export const prUrl = 'https://www.precisionroller.com';
